import { atom, selector } from "recoil";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";

export const customerReportListState = atom({ key: 'customerReportListState', default: [] })

// Empty by default: the figures on this report are lifetime ones, and a
// balance is a point-in-time number that no date range can narrow. Defaulting
// to a window left every total reading zero beside a non-zero balance.
export const customerReportFromDateState = atom({
    key: 'customerReportFromDateState',
    default: '',
})

export const customerReportToDateState = atom({
    key: 'customerReportToDateState',
    default: '',
})

export const modalConfigDefault = { size: "lg", wizard: false }

export const customerReportFilterState = selector({
    key: 'customerReportFilterState',
    get: ({ get }) => ([
        { label: 'From Date', size: 6, offset: 0, required: false, type: 'datepicker', value: get(customerReportFromDateState) },
        { label: 'To Date', size: 6, offset: 0, required: false, type: 'datepicker', value: get(customerReportToDateState) },
    ]),
    set: ({ set }, e) => {
        if (e.filterLabel === 'From Date') { set(customerReportFromDateState, e.value) }
        if (e.filterLabel === 'To Date') { set(customerReportToDateState, e.value) }
    }
})

export const formModes = { view: [{ name: 'Default View' }] }

// Shared by the report and the customer search screen — both render the same
// row shape, so the column definitions live in one place.
export const customerColumns = [
    { label: 'Customer', field: 'name', type: 'text', order: { table: 1 } },
    { label: 'Company', field: 'company_name', type: 'text', order: { table: 2 } },
    { label: 'Email', field: 'email', type: 'text', order: { table: 3 } },
    { label: 'Mobile', field: 'mobile_number', type: 'text', order: { table: 4 } },
    { label: 'Balance', field: 'balance', type: 'number', order: { table: 5 } },
    { label: 'Wallet Credit (excl. GST)', field: 'total_topped_up', type: 'number', order: { table: 6 } },
    { label: 'GST', field: 'total_gst', type: 'number', order: { table: 7 } },
    { label: 'Total Paid (incl. GST)', field: 'total_paid', type: 'number', order: { table: 8 } },
    { label: 'Total Spent', field: 'total_spent', type: 'number', order: { table: 9 } },
    { label: 'Vessels', field: 'vessel_count', type: 'number', order: { table: 10 } },
    { label: 'Last Activity', field: 'last_activity', type: 'date', order: { table: 11 } },
].map(c => ({
    ...c,
    create: [{ enabled: false }], update: ['same_as:create.0'], view: [{ enabled: true, size: 12 }],
}))

export const customerReportDataStructureState = selector({
    key: 'customerReportDataStructureState',
    get: ({ get }) => (
        customerColumns.filter((v) => {
            const page = get(pageState)
            const permissions = get(permissionState)
            if (!v.permission) { return true }
            let absolute = false;
            if (v.permission.substr(0, 1) === ":") { absolute = true; v.permission = v.permission.substr(1) }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})
